<div class="ui-modal">
  <div class="header flex-row space-between-center">
    {{ 'PERSONS.EDIT_PERSON' | translate }}
    <span class="ui-icon-close c-p" (click)="close()"></span>
  </div>
  <div class="body flex-col start-start flex gap-16 dialog-content narrower-input">
    <app-person-details-form
      [formControl]="personNameForm"
      [imageUrl]="getImagePath(person)"
      [imageUrlFallback]="getImagePath(person, false)"
    ></app-person-details-form>
  </div>
  <div class="footer flex-row end-center gap-8">
    <ui-button
      type="default"
      [text]="'COMMON.CANCEL' | translate"
      (clickAction)="close()"
    ></ui-button>
    <ui-button
      type="primary"
      [text]="'COMMON.SAVE' | translate"
      [disabled]="!isPersonNameValid() || isUpdating()"
      [loading]="isUpdating()"
      (clickAction)="save()"
    ></ui-button>
  </div>
</div>
